import { render, staticRenderFns } from "./DeepDesign.vue?vue&type=template&id=733a2c1c&"
import script from "./DeepDesign.vue?vue&type=script&lang=js&"
export * from "./DeepDesign.vue?vue&type=script&lang=js&"
import style0 from "./DeepDesign.vue?vue&type=style&index=0&id=733a2c1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports